import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { FormLabel, Switch } from "@mui/material";
import { Clear } from "@mui/icons-material";
import Button from "../../../../../components/CustomButtons/Button";
import CustomInput from "../../../../../components/CustomInput/CustomInput";
import SaveButton from "../../../../../components/CustomInput/SaveButton";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";

class Mobilenr extends React.Component {
  state = {
    output: {
      type: "mobilenr",
      name: "",
      descr: "",
      required: true,
      actief: true,
      sendToApi: true,
      printField: true,
      remember: true,
      anonymize: true,
      validator: null,
      ...this.props.value,
    },
  };

  save = (e) => {
    e.preventDefault();
    let row = { ...this.state.output };

    /**
     * Hacky omdat ik anders de oude value niet meer weer even toevoegen aan de onsave
     */
    if (this.props.value !== undefined) {
      row.oldName = this.props.value.name;
    }

    this.props.onSave(row);
    this.props.closeForm();
  };

  handleInputChange = (name, value) => {
    let newOutput = { ...this.state.output };
    newOutput[name] = value;
    this.setState({ output: newOutput });
  };

  handleCheckbox = (name) => (event) => {
    let newOutput = { ...this.state.output };
    newOutput[name] = event.target.checked;
    this.setState({ output: newOutput });
  };

  render() {
    const { classes } = this.props;

    return (
      <div style={{ background: "#f9f9f9" }}>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper tDefault={"Naam"} tKey={"vestigingen.form.customfields.mobilenr.label.name"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
              }}
              id={"naam"}
              inputProps={{
                type: "text",
                value: this.state.output.name,
                onChange: (e) => this.handleInputChange("name", e.target.value),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Omschrijving"}
                tKey={"vestigingen.form.customfields.mobilenr.label.descr"}
              />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
              }}
              id={"descr"}
              inputProps={{
                type: "text",
                value: this.state.output.descr,
                onChange: (e) => this.handleInputChange("descr", e.target.value),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Background image"}
                tKey={"vestigingen.form.customfields.text.label.image"}
              />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <input
              id={"backgroundimage"}
              onChange={(e) => {
                console.log("background image");
                let reader = new FileReader();
                reader.onloadend = () => {
                  this.handleInputChange("backgroundimage", reader.result);
                };
                reader.readAsDataURL(event.target.files[0]);
              }}
              type={"file"}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper tDefault={"Actief"} tKey={"vestigingen.form.customfields.mobilenr.label.actief"} />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.actief}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("actief")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Verplicht"}
                tKey={"vestigingen.form.customfields.mobilenr.label.required"}
              />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.required}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("required")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Onthouden"}
                tKey={"vestigingen.form.customfields.mobilenr.label.remember"}
              />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.remember}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("remember")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"sendToApi"}
                tKey={"vestigingen.form.customfields.select.label.sendToApi"}
              />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.sendToApi}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("sendToApi")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Print field"}
                tKey={"vestigingen.form.customfields.select.label.printField"}
              />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.printField}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("printField")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper
                tDefault={"Anonymize"}
                tKey={"vestigingen.form.customfields.select.label.anonymize"}
              />
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} sm={1} xs={12}>
            <Switch
              checked={this.state.output.anonymize}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.switchChecked,
                thumb: classes.switchIcon,
                track: classes.switchBar,
              }}
              onChange={this.handleCheckbox("anonymize")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer justify={"flex-end"}>
          <GridItem>
            <Button className={classes.marginRight} color={"danger"} onClick={this.props.closeForm}>
              <Clear /> <TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />
            </Button>
            <SaveButton
              buttonText={
                this.props.value === undefined ? (
                  <TranslationWrapper tDefault={"Opslaan"} tKey={"global.button.opslaan"} />
                ) : (
                  <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.aanpassen"} />
                )
              }
              hasError={false}
              onClick={this.save}
              saving={false}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default Mobilenr;
